import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { ProductCard } from "../components/ProductCard";
import { FadeIn } from "../components/FadeIn";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!q) {
      setProducts([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    api.get(`/products?q=${encodeURIComponent(q)}`)
      .then(({ data }) => setProducts(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <div className="pt-36 lg:pt-44 pb-24 px-6 lg:px-10 max-w-[1600px] mx-auto" data-testid="search-page">
      <FadeIn>
        <p className="overline-label mb-4">Search Results</p>
        <h1 className="font-display text-3xl sm:text-4xl text-capra-ivory mb-2">"{q}"</h1>
        <p className="text-sm text-capra-muted mb-12" data-testid="search-result-count">
          {loading ? "Searching…" : `${products.length} piece${products.length !== 1 ? "s" : ""} found`}
        </p>
      </FadeIn>

      {!loading && products.length === 0 ? (
        <p className="font-display italic text-lg text-capra-muted py-12">Nothing in the house matches your search — yet.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-10" data-testid="search-results-grid">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
